import { gql } from '@apollo/client';

export const GET_INVOICE_KPIS = gql`
  query GetInvoiceKPIs(
    $seller_id: String!,
    $from_date: String,
    $to_date: String
  ) {
    getInvoiceKPIs(
      seller_id: $seller_id,
      from_date: $from_date,
      to_date: $to_date
    ) {
      status
      logistic_total_records
      logistic_invoices_amount
      penalty_total_records
      penalty_invoices_amount
    }
  }
`;
